import { ToastVariant } from '../../components/Toast/toast.model';
import { toastService } from '../../components/Toast/toast.service';
import { firestore } from '../firebase';
import { FirestoreCollection } from '../firebase.models';

export enum OfferCheck {
  VERIFYING_IMAGES = 'VERIFYING_IMAGES',
  VERIFYING_DATA = 'VERIFYING_DATA',
  GENERATING_PROJECT_OFFER = 'GENERATING_PROJECT_OFFER',
  SENDING_PROJECT_OFFER = 'SENDING_PROJECT_OFFER',
  DONE = 'DONE',

  CHECKING_NETWORK = 'CHECKING_NETWORK',
  DOWNLOADING_DATA = 'DOWNLOADING_DATA',
  SIGNING_OFFER = 'SIGNING_OFFER',
  SAVE_REPORT = 'SAVE_REPORT',
  SENDING_OFFER = 'SENDING_OFFER',

  RESERVATION = 'RESERVATION',
  PREPARING_DOCUMENTS = 'PREPARING_DOCUMENTS',

  SIGNING_CONTRACT = 'SIGNING_CONTRACT',
  SENDING_CONTRACT = 'SENDING_CONTRACT',
}

export async function useUpdateOfferCheck(offerId: string, state: OfferCheck): Promise<void> {
  try {
    const docRef = firestore.collection(FirestoreCollection.OFFERS).doc(offerId);
    await docRef.update({ offerCheck: state });
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Nie udało się przejść do następnego kroku';
    toastService.show(errorMessage, 'Błąd!', { variant: ToastVariant.ERROR });
    throw error;
  }
}
